const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");
const ReactModal2 = require("react-modal2").default;
const {Portal} = require("../../core/view/Portal");
const Z = require("../../../shared/ZIndex");
const DisableScroll = require("../../core/util/DisableScroll");
const ScrollUtil = require("../../core/util/ScrollUtil");
const OfficeModalClose = require("../../core/view/OfficeModalClose");
const ImageLoader = require("../../core/util/ImageLoader");
const withVaultUpdate = require("../../core/hoc/withVaultUpdate");
const withContainerDims = require("../../core/hoc/withContainerDims");

const styles = require("./styles/OfficeModal.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultUpdate(Component, function(props, vaultState) {
		return {connected: vaultState.connected};
	});
	Component = withContainerDims(Component, {skipOnServer: true});
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "OfficeModalView",

		propTypes: {
			onClose: PT.func,
			cannotClose: PT.bool,
			//Determines zIndex based onwhether the modal backdrop should cover up the top & bottom bars
			level: PT.oneOf(["overBar", "warning"]).isRequired,
			backdropStyles: PT.object,
			backdropClass: PT.string,
			backdropWrapperClass: PT.string,
			modalStyles: PT.object,
			modalClass: PT.string,
			closeClass: PT.string,
			closeColor: PT.oneOf(["white", "gray"]),
			closeHideIcons: PT.bool,
			closeOnBackdropClick: PT.bool,
			// gateway is actually string|HTMLElement|()=>HTMLElement|null but PropTypes doesn't have that...
			portalContainer: PT.any, // null for no gateway, string for a gateway name other than office
			isScrollable: PT.bool, //non-fixed modal, scrollable
			isFixed: PT.bool, //fixed modal
			scrollTopOnOpen: PT.bool,

			//This is sometimes used with this modal, so adding it here and defaulting to true
			closeOnEsc: PT.bool,

			// Injected by HOCs
			connected: PT.bool.isRequired,
			containerDims: PT.shape({
				windowHeight: PT.number.isRequired,
			}).isRequired,
		},

		getDefaultProps: function() {
			return {
				portalContainer: null,
				closeOnEsc: true,
			};
		},

		getInitialState: function() {
			this.isScrollDisabled = false;
			return {};
		},

		disableScroll: function() {
			if (!this.isScrollDisabled) {
				this.isScrollDisabled = true;
				DisableScroll.disable();
			}
		},

		enableScroll: function() {
			if (this.isScrollDisabled) {
				this.isScrollDisabled = false;
				DisableScroll.enable();
			}
		},

		shouldScroll: function(props) {
			if (props.isScrollable || !this.backdropWrapper) return true;
			const realBackdrop = this.backdropWrapper.children[0];
			if (!realBackdrop) return true;
			const realBackdropHeight = realBackdrop.clientHeight;
			if (props.containerDims.windowHeight < realBackdropHeight) return true;
			return false;
		},

		updateScroll: function(props) {
			if (this.shouldScroll(props)) {
				this.enableScroll();
			} else {
				this.disableScroll();
			}
		},

		componentDidMount: function() {
			this.updateScroll(this.props);
			if (this.props.scrollTopOnOpen) {
				ScrollUtil.scrollTo("top");
			}
			// X button flickers when first hovered without this. Keep synced with
			// closeHoverIcon background rules in the css.
			ImageLoader.preload(
				global.BASE_URL + "assets/images/office/elements/x-icon.svg"
			);
		},

		componentWillUnmount: function() {
			this.enableScroll();
		},

		UNSAFE_componentWillReceiveProps: function(nextProps) {
			this.updateScroll(nextProps);
		},

		handleClose: function() {
			this.props.onClose();
		},

		render: function() {
			const backgroundZStyle = {zIndex: Z[this.props.level + "ModalBackdrop"]};
			const backdropStyles = _.extend(
				{},
				this.props.backdropStyles,
				backgroundZStyle
			);
			const modalStyles = _.extend({}, this.props.modalStyles, {
				zIndex: Z[this.props.level + "Modal"],
			});

			const closeButton = this.props.cannotClose ? null : (
				<OfficeModalClose
					handleClose={this.handleClose}
					useFallback={!this.props.connected}
					closeColor={this.props.closeColor}
					closeClass={this.props.closeClass}
					hideIcons={this.props.closeHideIcons}
				/>
			);

			const mainClass =
				this.props.isScrollable && !this.props.isFixed
					? styles.mainScroll
					: styles.main;
			const backdropClass =
				this.props.isScrollable && !this.props.isFixed
					? styles.backdropScroll
					: styles.backdrop;
			let modal = (
				<ReactModal2
					onClose={this.handleClose}
					closeOnEsc={this.props.closeOnEsc}
					closeOnBackdropClick={this.props.closeOnBackdropClick !== false}
					backdropClassName={
						(this.props.backdropClass || "") + " " + backdropClass
					}
					modalClassName={(this.props.modalClass || "") + " " + mainClass}
					backdropStyles={backdropStyles}
					modalStyles={modalStyles}
				>
					{closeButton}
					{this.props.children}
				</ReactModal2>
			);

			let wrapperClass = styles.backdropWrapper;
			if (this.props.backdropWrapperClass)
				wrapperClass += " " + this.props.backdropWrapperClass;

			//Non-scrollable modals need a wrapper that lets them become scrollable
			//if they are too short. See OfficeModal.css for details.
			if (!this.props.isScrollable || this.props.isFixed) {
				modal = (
					<div
						ref={r => (this.backdropWrapper = r)}
						className={wrapperClass}
						style={backgroundZStyle}
					>
						{modal}
					</div>
				);
			}

			if (this.props.portalContainer) {
				return <Portal container={this.props.portalContainer}>{modal}</Portal>;
			} else {
				return modal;
			}
		},
	})
);
